import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "../SafeHTML";
import { Tab } from "semantic-ui-react";
import "semantic-ui-css/components/tab.min.css";
import MeasurementIcon from "../../../img/scale.svg";
import TechnicalIcon from "../../../img/g1800.svg";
import PerformanceIcon from "../../../img/Layer14.svg";
import UserInterfaceIcon from "../../../img/user-interface.svg";
import CommunicationIcon from "../../../img/talking.svg";
import ElectricalIcon from "../../../img/flash.svg";

export default class Specifications extends React.Component {
  static propTypes = {
    specifications: PropTypes.arrayOf(
      PropTypes.shape({
        category: PropTypes.string,
        content: PropTypes.string,
      })
    ),
  };

  constructor(props) {
    super(props);
    this.state = {
      tabPanes: [],
      slectedSpecIndex: 0,
      menuOpen: false,
      activeIndex: 0,
      selectedHotspotIndex: 1,
      selectedHotspotContent: null,
      selectedImage: null,
      jsonHotspotData: [],
      whatContent: null,
      header: null,
      howContent: null,
      contentID: null,
      toggleImage: false,
      tempImage: null,
      currentIndex: 0,
      isLastSlide: false,
      isFirstSlide: true,
      showArrows: true,
      selectedIndex: 0,
      altImageSelected: false,
      selectedHotspotID: null,
      isSelectedProductImage: false,
      isBlinkingHotspot: false,
      visitedHotspotsArr: [],
      isColorFlexL2Page: false,
    };
    this.icons = [
      MeasurementIcon,
      TechnicalIcon,
      PerformanceIcon,
      UserInterfaceIcon,
      CommunicationIcon,
      ElectricalIcon,
    ];
  }

  componentDidMount() {
    try {
      let menu = document.querySelector(".spec-tabs .menu");
      let isColorFlexL2 = window.location.pathname.includes("colorflex-l2") || window.location.pathname.includes("colorflex-l2-tomato") || window.location.pathname.includes("colorflex-l2-citrus");

      if (isColorFlexL2) {
        menu.classList.add("open");
      }
    } catch {
      // console.log("in hotspot")
    }

    this.populateTabPanes();
    let isColorFlexL2 = window.location.pathname.includes("colorflex-l2") || window.location.pathname.includes("colorflex-l2-tomato") || window.location.pathname.includes("colorflex-l2-citrus");
    let endpoint = window.location.pathname.split('/').filter(Boolean).pop();

    if (isColorFlexL2 || endpoint === "benchtop-spectrophotometers" || endpoint === "colorflex-l2" || endpoint === "colorflex-l2-tomato" || endpoint === "colorflex-l2-citrus") {
      this.setState({ menuOpen: true, isColorFlexL2Page: true });
      import("../../../scss/components/Products/SpecificationsNew");
    } else {
      this.setState({ menuOpen: false });
      import("../../../scss/components/Products/Specifications");
    }

    if (this.props.specifications[0]?.category === "image_hotspot") {
      const sectionElement = document.querySelector(
        'section[data-component-type="Specifications"]'
      );

      if (sectionElement) {
        sectionElement.setAttribute("data-component-type", "hotspotsection");
      }

      var firstImageHotspot = this.props.specifications[0]?.image?.url;
      var firstImageHotspotInfo = this.props.specifications[0]?.content;
      let jsonString = firstImageHotspotInfo.replace(/<\/?p[^>]*>/g, "");
      jsonString = jsonString.replace(/&quot;/g, '"');
      let jsonObject = JSON.parse(jsonString);
      let firstImageWhatData = jsonObject[0]?.content?.whatdata;
      let firstImageHeader = jsonObject[0]?.header;
      let firstImageHowData = jsonObject[0]?.content?.howdata;
      let contentID = jsonObject[0]?.id;

      const visitedHotspots = new Array(jsonObject.length).fill(false);
      if (jsonObject.length > 1) {
        visitedHotspots[1] = true;
      }

      this.setState({
        selectedImage: firstImageHotspot,
        jsonHotspotData: jsonObject,
        howContent: firstImageHowData,
        whatContent: firstImageWhatData,
        header: firstImageHeader,
        contentID,
        visitedHotspotsArr: visitedHotspots,
      });

      // Auto-select the first image
      this.handleHotspotImage(this.props.specifications[0], 0);
    }
  }

  toggleMenu() {
    let isMenuOpen = this.state.menuOpen;
    let menu = document.querySelector(".spec-tabs .menu");
    if (isMenuOpen) menu.classList.remove("open");
    else menu.classList.add("open");
    this.setState({ menuOpen: !isMenuOpen });
  }

  populateTabPanes = () => {
    let panes = [];
    this.props.specifications.forEach((objItem, index) => {
      let icon = this.icons[index];
      if (window.location.pathname.split('/').filter(Boolean).pop() != "colorflex-l2" && window.location.pathname.split('/').filter(Boolean).pop() != "colorflex-l2-tomato" && window.location.pathname.split('/').filter(Boolean).pop() != "colorflex-l2-citrus") {
        panes.push({
          menuItem: {
            key: index,
            content: objItem.category,
          },
          render: () => (
            <div className="container hello">
              <Tab.Pane>
                <SafeHTML>{objItem.content}</SafeHTML>
              </Tab.Pane>
            </div>
          ),
        });
      } else {
        panes.push({
          menuItem: {
            key: index,
            icon: (
              <img
                className="specs-icons"
                src={icon}
                alt={objItem.category}
                style={{ width: "20px" }}
              />
            ),
            content: objItem.category,
          },
          render: () => (
            <div className="container in-correct">
              <Tab.Pane>
                <SafeHTML>{objItem.content}</SafeHTML>
              </Tab.Pane>
            </div>
          ),
        });
      }
    });
    this.setState({ tabPanes: panes });
  };

  handleTabChange = (e, { activeIndex }) => {
    this.setState({ menuOpen: false, activeIndex: activeIndex });
    let menu = document.querySelector(".spec-tabs .menu");
    if (!this.state.isColorFlexL2Page) {
      menu.classList.remove("open");
    }
  };

  selectHotspot = (index, content, item) => {
    const { jsonHotspotData, visitedHotspotsArr } = this.state;
    const updatedHotspots = new Array(jsonHotspotData.length).fill(false);
    updatedHotspots[index] = false;

    const nextIndex = index + 1;
    if (nextIndex < jsonHotspotData.length) {
      updatedHotspots[nextIndex] = true;
    }

    this.setState({
      whatContent: content?.whatdata,
      howContent: content?.howdata,
      header: item.header,
      contentID: item?.id,
      selectedHotspotIndex: item?.id,
      altImageSelected: false,
      visitedHotspotsArr: updatedHotspots,
    });

    if (item?.selectedImageIndex == item?.targetImageIndex) {
      const imgSrcToToggleBack = document.querySelector(".lg-image-hotspot").src;

      let targetImageIndex = item?.targetImageIndex;
      if (item?.id == item?.altimageid) {
        if (item?.id === 1) {
          this.setState({
            selectedImage: this.props.specifications[this.state.slectedSpecIndex]?.image.url,
            selectedHotspotID: item?.id,
            altImageSelected: true,
            toggleImage: true,
            tempImage: imgSrcToToggleBack,
          });
        } else if (item?.id === 3) {
          this.setState({
            selectedImage: this.props.specifications[this.state.slectedSpecIndex]?.altImage1.url,
            selectedHotspotID: item?.id,
            altImageSelected: true,
            toggleImage: true,
            tempImage: imgSrcToToggleBack,
          });
        } else {
          this.setState({
            selectedImage: this.props.specifications[this.state.slectedSpecIndex]?.altImage.url,
            selectedHotspotID: item?.id,
            altImageSelected: true,
            toggleImage: true,
            tempImage: imgSrcToToggleBack,
          });
        }
      }
    } else {
      if (this.state.toggleImage) {
        this.setState({
          selectedImage: this.state.tempImage,
          toggleImage: false,
        });
      }
    }
  };

  handleHotspotImage = (spectItem, specIndex) => {
    this.setState({ toggleImage: false, selectedHotspotIndex: 1 });

    let jsonString = spectItem.content.replace(/<\/?p[^>]*>/g, "");
    jsonString = jsonString.replace(/&quot;/g, '"');
    let jsonObject = JSON.parse(jsonString);
    let imgDataWhenClicked = jsonObject[0];

    const index = this.props.specifications.findIndex(item =>
      item.image === spectItem.image && item.content === spectItem.content
    );
    this.setState({ slectedSpecIndex: index });

    const visitedHotspots = new Array(jsonObject.length).fill(false);
    if (jsonObject.length > 1) {
      visitedHotspots[1] = true;
    }

    this.setState({
      selectedIndex: specIndex,
      altImageSelected: false,
      selectedImage: spectItem?.image?.url,
      jsonHotspotData: jsonObject,
      contentID: imgDataWhenClicked?.id,
      header: imgDataWhenClicked?.header,
      howContent: imgDataWhenClicked?.content?.howdata,
      whatContent: imgDataWhenClicked?.content?.whatdata,
      visitedHotspotsArr: visitedHotspots,
      isColorFlexL2Page: false,
    });
  };

  handleNext = () => {
    const { currentIndex } = this.state;
    if (currentIndex < this.props.specifications.length - 3) {
      this.setState(
        { currentIndex: currentIndex + 1 },
        this.updateButtonStates
      );
    }
  };

  handlePrev = () => {
    const { currentIndex } = this.state;
    if (currentIndex > 0) {
      this.setState(
        { currentIndex: currentIndex - 1 },
        this.updateButtonStates
      );
    }
  };

  updateButtonStates = () => {
    const { currentIndex } = this.state;
    this.setState({
      isFirstSlide: currentIndex === 0,
      isLastSlide: currentIndex >= this.props.specifications.length - 3,
    });
  };

  render() {
    const { currentIndex, isFirstSlide, isLastSlide, showArrows } = this.state;

    let str = window.location.href;
    let product_text;
    if (str.includes("/es/")) {
      product_text = "Especificaciones-del Producto";
    }
    if (str.includes("/en/")) {
      product_text = "Product-Specifications";
    }
    if (str.includes("/en-uk/")) {
      product_text = "Product-Specifications";
    }

    const image_hotspot = this.props.specifications;
    const { selectedHotspotIndex, jsonHotspotData } = this.state;
    const { selectedHotspotContent } = this.state;

    return (
      <div id="cat4">
        {(image_hotspot[0].category != "image_hotspot" && image_hotspot[0].category != "Frequently Asked Questions") && image_hotspot[0].category != "Preguntas frecuentes" && (
          <section id="products-detail-specs-section" className="spec-section">
            {this.state.isColorFlexL2Page? <div>
              <div
                className={
                  "spec-tabs-head"
                   + (this.state.menuOpen ? " open" : "")
                }
                // onClick={() => this.toggleMenu()}
              >
                <h2 className="spec-tabs-title" style={{ textAlign: "center" }}>
                  <span>{product_text.split("-")[0]}</span>
                  <span style={{ color: "#428bc5", marginLeft: "10px" }}>
                    {product_text.split("-")[1]}
                  </span>
                </h2>
                <div className="specs-desc-product-detail">
                  {this.props.specifications[0]?.header}
                </div>
              </div>
              <div className="spec-tabs">
                <Tab
                  activeIndex={this.state.activeIndex}
                  onTabChange={this.handleTabChange}
                  menu={{ fluid: true, vertical: true }}
                  panes={this.state.tabPanes}
                />
              </div>
            </div>:
            <div className="container">
                <div className={"spec-tabs-head" + (this.state.menuOpen ? " open" : "")} onClick={() => this.toggleMenu()}>
                    <h3 className="spec-tabs-title">{product_text}</h3>
                </div>
                <div className="spec-tabs">
                    <Tab onTabChange={this.handleTabChange} menu={{ fluid: true, vertical: true }} panes={this.state.tabPanes} />
                </div>
            </div>
            }
          </section>
        )}
        {image_hotspot[0].category === "image_hotspot" && (
          <div>
            <div>
              <div className="product-image-hotspot">
                {/* <h4 className="ml-20-hotspot-text bold-txt">What is it</h4> */}
                <div style={{ display: "flex" }}>
                  <span className="hotspot-info-number">
                    {this.state.contentID}
                  </span>
                  <div style={{display:'flex', flexDirection:'column'}}>
                  <h3 className="hotspotHeader" style={{marginBottom:'10px'}}>
  {this.state.header && this.state.header.includes('/^') 
    ? (
        <>
          <strong><SafeHTML>{this.state.header.split('/^')[0]}</SafeHTML></strong>
          <br />
          <strong><SafeHTML>{this.state.header.split('/^')[1]}</SafeHTML></strong>
        </>
      )
    : <strong><SafeHTML>{this.state.header}</SafeHTML></strong>
  }
</h3>
                  <span className="hotspotContent">
                    <SafeHTML>{this.state.whatContent}</SafeHTML>
                  </span>{" "}
                  </div>
                </div>
                {/* <br /> <br /> */}

               {this.state.howContent && (
                <>
                {/* <h4
                  className="ml-20-hotspot-text bold-txt"
                  // style={{ marginTop: "20px" }}
                >
                  How it helps
                </h4> */}

                <div style={{ display: "flex" }}>
                  <p className="ml-20-hotspot-text">
                    <SafeHTML>{this.state.howContent}</SafeHTML>
                  </p>
                </div>
                </>
                )}


              </div>
            </div>

            <div>

            <div
              className="hotspot-and-product-img-container"
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "25px",
              }}
            >
              <div className="vertical-htpss-container">
                {this.state.jsonHotspotData.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`lg-hotspot--top-left ${
                        selectedHotspotIndex === index + 1
                          ? "lg-hotspot--selected"
                          : ""
                      }`}
                    >
                      <div
                        className={
                          this.state.visitedHotspotsArr[index]
                            ? "img-hotspot-button single-vertical-hotspots-grp blinking-hotspot-butn"
                            : "img-hotspot-button single-vertical-hotspots-grp"
                        }
                        // className="img-hotspot-button single-vertical-hotspots-grp"
                        onClick={() =>
                          this.selectHotspot(index, item.content, item)
                        }
                        style={{ margin: "25px 0", border: " 1px solid black" }}
                      >
                        {index + 1}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="lg-container-hotspot large-img-container">
                <img
                  className="lg-image-hotspot"
                  src={this.state.selectedImage}
                  alt="product-image-with-hotspot"
                />
                {/* {this.state.jsonHotspotData.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{ top: item.top, left: item.left }}
                      className={`lg-hotspot  lg-hotspot--top-left ${
                        selectedHotspotIndex === index + 1
                          ? "lg-hotspot--selected"
                          : ""
                      }`}
                    >
                      {!this.state.altImageSelected ? (
                        <div
                          id="hotspot-in-imgs"
                          className="img-hotspot-button"
                          onClick={() =>
                            this.selectHotspot(index, item.content, item)
                          }
                        >
                          {index + 1}
                        </div>
                      ) : (
                        <div>
                          {item.isaltimage && (
                            <div
                              id="hotspot-in-imgs"
                              className="img-hotspot-button"
                              onClick={() =>
                                this.selectHotspot(index, item.content, item)
                              }
                            >
                              {index + 1}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })} */}
              </div>
            </div>

            <div
              className={
                this.state.isColorFlexL2Page
                  ? "feature-hotspot-images-product colorflex-l2-feature-hotspot"
                  : "feature-hotspot-images-product"
              }
            >
              {showArrows && (
                <button
                  onClick={() => this.handlePrev()}
                  id="prev-btn-product"
                  className="arrow-left product-button-arrow"
                  disabled={isFirstSlide}
                >
                  &#10094;
                </button>
              )}

              {this.props.specifications
                .slice(currentIndex, currentIndex + 3)
                .map((spectItem, specIndex) => {
                  let jsonString = spectItem.content.replace(
                    /<\/?p[^>]*>/g,
                    ""
                  );
                  jsonString = jsonString.replace(/&quot;/g, '"');
                  let jsonObject = JSON.parse(jsonString);

                  const isSelected = this.state.selectedIndex === specIndex;
                  const imagesItems = isSelected
                    ? "lg-container-hotspot selected-img-with-bg"
                    : "lg-container-hotspot";

                  return (
                    <div
                      className={"container-hotspot" + specIndex}
                      key={specIndex}
                      onClick={() =>
                        this.handleHotspotImage(spectItem, specIndex)
                      }
                    >
                      <div
                        className={imagesItems}
                        // className = "lg-container-hotspot"
                      >
                        <img
                          className="carousel-imgs"
                          src={
                            //   selectedHotspotIndex == 1 ? img1 :
                            spectItem.image.url
                          }
                          height="420"
                          width="370"
                        />
                      </div>
                    </div>
                  );
                })}

              {showArrows && (
                <button
                  onClick={() => this.handleNext()}
                  id="next-btn-product"
                  className="arrow-right product-button-arrow"
                  disabled={isLastSlide}
                >
                  &#10095;
                </button>
              )}
            </div>

            </div>


          </div>
        )}
        {(image_hotspot[0].category === "Frequently Asked Questions" || image_hotspot[0].category === "Preguntas frecuentes") && (
          <div>
            {image_hotspot[0].category=== "Frequently Asked Questions" ?<h2 class="post-info-title post-info-title-faq product-info-title" style={window.location.pathname.includes('/products/')? !window.location.pathname.includes('/benchtop-spectrophotometers/')? {textAlign:'center',marginTop:'0px'}:{textAlign:'center'}:{textAlign:'center'}}>Frequently Asked <span style={{ color:'#428bc5'}}>Questions</span></h2> 
            :<h2 class="post-info-title post-info-title-faq product-info-title" style={window.location.pathname.includes('/products/')? !window.location.pathname.includes('/benchtop-spectrophotometers/')? {textAlign:'center',marginTop:'0px'}:{textAlign:'center'}:{textAlign:'center'}}>Preguntas <span style={{ color:'#428bc5'}}>frecuentes</span></h2>
            }
            <div className="accordian_container">
              <div className="accordions">
              {this.props.specifications.map((faqItem, faqIndex) => {
                  return (
                    <div class="accordion">
                      <input type="checkbox" id={`faq-${faqIndex}`} />
                      <label for={`faq-${faqIndex}`} class="accordion__header">
                        <span class="accordion__index">{faqIndex + 1}.</span>
                        <span class="accordion__question">{faqItem.header}</span>
                        <span class="accordion__toggle"></span>
                      </label>
                      <div className="accordion__content">
                        <SafeHTML>
                          {faqItem.content}
                        </SafeHTML>
                      </div>
                    </div>
                  );
                })
                }
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
